import {
  REDEEM_CLOSE_POPUP,
  REDEEM_OPEN_CONFIRM,
  REDEEM_OPEN_FAIL,
  REDEEM_REQUEST,
  REDEEM_COUNT_SUCCESS,
  REDEEM_COUNT, 
   REDEEM_OPEN_BOOKING_CONFIRM,
  REDEEM_OPEN_SUCCESS
} from "./types";

// POPUP : 2
export const redeemClosePopup = () => {
  return {
    type: REDEEM_CLOSE_POPUP,
  };
};

export const redeemOpenConfirm = () => {
  return {
    type: REDEEM_OPEN_CONFIRM,
  };
};

export const redeemOpenFail = (payload) => {
  return {
    type: REDEEM_OPEN_FAIL,
    payload: payload,
  };
};

export const redeemOpenBookingConfirm = (payload) => {
  return {
    type: REDEEM_OPEN_BOOKING_CONFIRM,
    payload: payload,
  };
};

export const redeemOpenSuccess= (payload) => {
  return {
    type: REDEEM_OPEN_SUCCESS,
    payload: payload,
  };
};

export const redeemRequest = (payload) => {
  return {
    type: REDEEM_REQUEST,
    payload: payload,
  };
};

export const redeemCountSuccess = (payload) => {
  return {
    type: REDEEM_COUNT_SUCCESS,
    payload: payload,
  };
};

export const redeemCount = (payload) => {
  return {
    type: REDEEM_COUNT,
    payload: payload,
  };
};
